import React from 'react';
import Chip from '@mui/material/Chip';

export interface IChipsProps {
  chips: { key: string; value: any; disabled?: boolean }[];
  selected: number;
  setSelected: (_value: number) => void;
  width?: string;
  variant?: 'filled' | 'outlined';
  children?: React.ReactNode;
}
export const ToggleChips = ({ chips, selected, setSelected, width = '3rem', variant, children }: IChipsProps) =>
  chips?.length ? (
    <div className="flex items-center gap-1 bg-gray-100 rounded-full p-1">
      {chips.map(({ key, value, disabled }) => (
        <button
          key={key}
          onClick={() => !disabled && setSelected(value)}
          disabled={disabled}
          style={{ width }}
          className={`py-1 text-xs rounded-full transition-colors font-medium ${
            disabled
              ? 'text-gray-400 cursor-not-allowed'
              : value === selected
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          {key}
        </button>
      ))}
      {children}
    </div>
  ) : null;
